import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Don't retry on 404s or other client errors
        if (error?.status >= 400 && error?.status < 500) {
          return false;
        }
        // Retry network errors and 5xx errors once
        return failureCount < 1;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff: 1s, 2s, 4s
      staleTime: 5 * 60 * 1000, // cache for 5 minutes
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
